import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkHierarchy } from '../models/models'

export class SavePkHierarchyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/saveHierarchy',
      requesterInfo,
    })
  }

  public async saveHierarchy(request: IPkHierarchy): Promise<string> {
    return await this.postAsync<string>(request)
  }
}
